/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export function durationPicker(element) {
  function secondsToHMS(d) {
    d = Number(d);
    return {
      h: Math.floor(d / 3600),
      m: Math.floor(d % 3600 / 60),
      s: Math.floor(d % 3600 % 60)
    };
  }
  var randomId = Math.floor(Math.random() * 1000000000);
  element.id = element.id ? element.id : randomId;
  var elementId = element.id;
  var elementInitSeconds = parseInt(element.value);
  var isDPInit = !!document.getElementById('dp-' + elementId);
  if (isDPInit) return;
  var HMS = secondsToHMS(elementInitSeconds);
  var pickerTemplate = '<div id="dp-' + elementId + '"><input type="text" class="form-control duration-picker-input" readonly>' + '<div class="duration-picker" role="tooltip">' + '<div class="duration-picker-content">' + '<label><input class="form-control h-input" type="number" min="0" max="9999" value="' + HMS.h + '" autocomplete="off">' + i18n.ngettext('Hour', 'Hours', 0) + '</label>' + '<label><input class="form-control m-input" type="number" min="0" max="59" value="' + HMS.m + '" autocomplete="off">' + i18n.ngettext('Minute', 'Minutes', 0) + '</label>' + '<label><input class="form-control s-input" type="number" min="0" max="59" value="' + HMS.s + '" autocomplete="off">' + i18n.ngettext('Second', 'Seconds', 0) + '</label>' + '</div>' + '<div class="duration-picker-arrow" data-popper-arrow></div>' + '</div></div>';
  element.insertAdjacentHTML('afterend', pickerTemplate);
  element.style.display = 'none';
  var dpElement = document.getElementById('dp-' + elementId);
  var dpPickerInput = dpElement.querySelector('.duration-picker-input');
  var dpPicker = dpElement.querySelector('.duration-picker');
  updatePickerInput(dpPickerInput, elementInitSeconds);
  var popperInstance = Popper.createPopper(dpPickerInput, dpPicker, {
    placement: 'bottom-start',
    modifiers: [{
      name: 'arrow',
      options: {
        // enabled: false,
        padding: 15
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 8]
      }
    }]
  });
  function showPicker() {
    // Make the tooltip visible
    dpPicker.setAttribute('data-show', '');
    // Enable the event listeners
    popperInstance.setOptions({
      modifiers: [{
        name: 'eventListeners',
        enabled: true
      }, {
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }]
    });
    // Update its position
    popperInstance.update();
  }
  function hidePicker() {
    // Hide the tooltip
    dpPicker.removeAttribute('data-show');
    // Disable the event listeners
    popperInstance.setOptions({
      modifiers: [{
        name: 'eventListeners',
        enabled: false
      }]
    });
  }
  var showEvents = ['click', 'touchend'];
  showEvents.forEach(function (event) {
    dpPickerInput.addEventListener(event, showPicker);
  });
  document.addEventListener('click', function (event) {
    var isClickInside = dpPicker.contains(event.target) || dpPickerInput.contains(event.target);
    if (!isClickInside) hidePicker();
  });
  var pickerInputs = dpPicker.querySelectorAll('input');
  for (var i = 0; i < pickerInputs.length; i++) {
    pickerInputs[i].addEventListener('input', function () {
      var hoursInput = dpPicker.querySelector('.h-input');
      var minutesInput = dpPicker.querySelector('.m-input');
      var secondsInput = dpPicker.querySelector('.s-input');
      hoursInput.value = hoursInput.value.replace(/\D+/, '');
      minutesInput.value = minutesInput.value.replace(/\D+/, '');
      secondsInput.value = secondsInput.value.replace(/\D+/, '');
      var seconds = (parseInt(hoursInput.value) ? parseInt(hoursInput.value) : 0) * 60 * 60 + (parseInt(minutesInput.value) ? parseInt(minutesInput.value) : 0) * 60 + (parseInt(secondsInput.value) ? parseInt(secondsInput.value) : 0);
      updatePickerInput(dpPickerInput, seconds);
    });
  }
  function updatePickerInput(pickerInput, seconds) {
    var HMS = secondsToHMS(seconds);
    if (seconds > 0) {
      var durationHourTemplate = HMS.h + ' ' + i18n.ngettext('Hour', 'Hours', HMS.h) + ' ';
      var durationMinTemplate = HMS.m + ' ' + i18n.ngettext('Minute', 'Minutes', HMS.m) + ' ';
      var durationSecTemplate = HMS.s + ' ' + i18n.ngettext('Second', 'Seconds', HMS.s);
      pickerInput.value = (HMS.h > 0 ? durationHourTemplate : '') + durationMinTemplate + durationSecTemplate;
    } else {
      pickerInput.value = '';
    }
    element.value = seconds;
  }
}
export function durationPickerInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var durationPickerElements = container.querySelectorAll(".duration-picker");
  for (var i = 0; i < durationPickerElements.length; i++) {
    durationPicker(durationPickerElements[i]);
  }
}